import { cn } from '@/lib/utils';

const LOGO_SRC = `${import.meta.env.BASE_URL}assets/images/qtraceai-logo.png`;

type BrandLogoProps = {
  className?: string;
};

const BrandLogo = ({ className }: BrandLogoProps) => (
  <img
    src={LOGO_SRC}
    alt="QTraceAi"
    className={cn(
      'block h-5 w-auto max-w-full object-contain object-left',
      className,
    )}
  />
);

export default BrandLogo;
